import React from 'react'
import {Header, Image} from 'semantic-ui-react'
import avatar from './avatar.png'

const Title = ({siteTitle}) => (
  <Header as='h1' textAlign='center' className='my-name'>
    {siteTitle} <Image circular src={avatar}/>
  </Header>
);

export default Title



// WEBPACK FOOTER //
// ./src/components/title.js